// Libs
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Components
import App from './App';

// Utils
import { initDatadogRum } from '~fpu/shared/utils/datadog-rum';

import './index.css';

initDatadogRum();

const container = document.getElementById('root');
const root = createRoot(container!);

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } }
});

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
